// src/stages/stage1Plant/environment/PlantGround.jsx
import React from "react";
import * as THREE from "three";
import { useTexture } from "@react-three/drei";

export default function PlantGround({
  size = 16,
  y = 0,
  albedo = "/stageAssets/stage1-plant/forest_leaves_04_diff_1k.jpg",
  roughnessMap = "/stageAssets/stage1-plant/forest_leaves_04_rough_1k.jpg",
  repeat = 6,
}) {
  const [map, rough] = useTexture([albedo, roughnessMap]);

  [map, rough].forEach((t) => {
    if (!t) return;
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    t.repeat.set(repeat, repeat);
    t.anisotropy = 4;
    t.needsUpdate = true;
  });

  map.colorSpace = THREE.SRGBColorSpace;

  return (
    <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, y, 0]} receiveShadow>
      <planeGeometry args={[size, size]} />
      <meshStandardMaterial
        map={map}
        roughnessMap={rough}
        // color="#c7b79e"
        color="#b39f84"
        roughness={1}
      />
    </mesh>
  );
}